// imports
import loader from "./loader.svg"
import dark_symbol from "./dark_vibe_logo.png"
import light_symbol from "./light_vibe_logo.png"
import loaderWhite from "./loaderWhite.svg"

// exports
export const LOADER = loader
export const LOADER_WHITE = loaderWhite
export default { dark_symbol, light_symbol }
